<template>
  <Layout :tituloPagina="'Sistema | Ajustes | Pasarelas pago | '+pasarela.nombre+ ' | Edición' ">
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <div class="card shadow-sm border">
          <div class="card-header justify-content-between d-flex align-items-center border-bottom py-3">
            <h4 class="card-title mb-0 font-size-15 fw-bold d-flex align-items-center">
              Editar pasarela de pago {{ pasarela.id != null ? '('+pasarela.nombre+')': '' }}
              <span class="badge bg-success ms-2 font-size-11" v-if="configuracion.activa">
                <i class="mdi mdi-circle me-1 font-size-10"></i>Activa
              </span>
              <span class="badge bg-secondary ms-2 font-size-11" v-else>
                <i class="mdi mdi-circle-outline me-1 font-size-10"></i>Inactiva
              </span>
            </h4>
            <div>
              <div class="dropdown">
                <a
                  class="dropdown-toggle"
                  href="javascript: void(0);"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <eva-icon
                    name="more-horizontal-outline"
                    data-eva-width="20"
                    data-eva-height="20"
                    :class="{
                      'fill-dark': $store.state.layout.layoutMode == 'light',
                      'fill-white': $store.state.layout.layoutMode == 'dark'
                    }"
                  ></eva-icon>
                </a>
                <ul class="dropdown-menu dropdown-menu-end shadow">
                  <li>
                    <a
                      href="#"
                      class="dropdown-item"
                      onclick="return false"
                      @click="guardar()"
                      v-if="!bandera_spinner"
                    >
                      <i class="mdi mdi-content-save text-success me-2"></i>
                      Guardar
                    </a>
                    <span class="dropdown-item disabled" v-if="bandera_spinner">
                      <i class="mdi mdi-concourse-ci mdi-spin me-2"></i>
                      Guardar
                    </span>
                  </li>
                  <li>
                    <a
                      class="dropdown-item" href="#"
                      onclick="return false;" @click="cerrar()"
                    >
                      <i class="mdi mdi-close text-dark me-2"></i>
                      Cerrar
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body p-4">
            <div class="row align-items-center">
              <div class="col-md-12 mb-3">
                <div class="d-flex align-items-center justify-content-between p-3 rounded bg-light border">
                  <div>
                    <label class="font-size-13 fw-semibold mb-0">Pasarela Activa</label>
                    <div class="text-muted font-size-12">
                      {{ configuracion.activa ? 'Pasarela activa y lista para procesar pagos' : 'Habilite para activar el procesamiento con FlowPay' }}
                    </div>
                  </div>
                  <div class="form-check form-switch form-switch-lg mb-0">
                    <input
                      :checked="configuracion.activa"
                      @change="
                        configuracion.activa = !configuracion.activa,
                        mensajePasarelaActiva()
                      "
                      class="form-check-input style-pointer"
                      type="checkbox"
                      id="activarPasarela"
                    />
                    <label class="form-check-label" for="activarPasarela"></label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="configuracion.activa || aplicacion.access_token">
              <div class="col-md-12 mb-3">
                <div class="p-3 rounded border bg-light">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <label class="font-size-13 fw-bold mb-0 text-dark">
                      <i class="mdi mdi-key-variant text-primary me-1"></i>
                      Access Token FlowPay
                    </label>
                    <span class="badge bg-success" v-if="aplicacion.access_token">
                      <i class="mdi mdi-check-circle-outline me-1"></i>Generado
                    </span>
                    <span class="badge bg-warning text-dark" v-else>
                      <i class="mdi mdi-clock-outline me-1"></i>Pendiente de registro
                    </span>
                  </div>
                  <div class="input-group">
                    <input
                      :type="mostrar_access_token ? 'text' : 'password'"
                      class="form-control font-monospace"
                      :class="$store.state.layout.layoutMode == 'dark' ? 'bg-dark text-white' : 'bg-white text-dark'"
                      id="accessTokenFlowPay"
                      readonly
                      :value="aplicacion.access_token"
                      placeholder="Access Token se generará al activar la pasarela"
                    />
                    <button
                      class="btn"
                      :class="mostrar_access_token ? 'btn-success' : 'btn-primary'"
                      type="button"
                      title="Mostrar/Ocultar Access Token"
                      @click="mostrar_access_token = !mostrar_access_token"
                    >
                      <i
                        class="mdi"
                        :class="{
                          'mdi-eye': mostrar_access_token,
                          'mdi-eye-off': !mostrar_access_token
                        }"
                      ></i>
                    </button>
                    <button
                      class="btn"
                      :class="copiado_token ? 'btn-success' : 'btn-primary'"
                      type="button"
                      title="Copiar Access Token"
                      @click="copiarAccessToken"
                      :disabled="!aplicacion.access_token"
                    >
                      <i class="mdi me-1" :class="copiado_token ? 'mdi-check-all' : 'mdi-content-copy'"></i>
                      {{ copiado_token ? '¡Copiado!' : 'Copiar' }}
                    </button>
                  </div>
                  <small class="text-muted d-block mt-2" v-if="aplicacion.access_token">
                    <i class="mdi mdi-information-outline me-1"></i>
                    Este Access Token pertenece a la aplicación registrada automáticamente para la pasarela FlowPay.
                  </small>
                </div>
              </div>
            </div>

            <hr style="margin-top: 1.25rem; margin-bottom: 1.25rem;" v-if="false">
            
            <div class="row align-items-center" v-if="false">
              <div class="col-md-6">
                <label class="fw-semibold font-size-13 mb-1">Moneda</label>
                <select class="form-select" v-model="configuracion.id_moneda">
                  <option :value="null">Seleccionar</option>
                  <option 
                    :style="!moneda.soportada ? 'color: red;': ''"
                    v-for="moneda in monedas_soportadas"
                    :value="moneda.id"
                    :key="'moneda-'+moneda.id"
                  >
                    ({{moneda.codigo}}) - {{moneda.nombre}} {{!moneda.soportada ? '** Moneda no soportada **': ''}}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="fw-semibold font-size-13 mb-1">Cobrar comisión</label>
                <div class="form-check form-switch form-switch-lg mb-0 mt-1">
                  <input
                    :checked="configuracion.comision"
                    @change="configuracion.comision = !configuracion.comision"
                    class="form-check-input style-pointer"
                    type="checkbox"
                    id="comision"
                  />
                  <label class="form-check-label" for="comision"></label>
                </div>
              </div>
            </div>
            <div class="row mt-3 p-3 bg-light rounded border mx-0" v-show="configuracion.comision" v-if="false">
              <div class="col-md-6 mb-2">
                <label class="fw-semibold font-size-13 mb-1">Porcentaje de comisión</label>
                <div class="input-group">
                  <input
                    class="form-control"
                    ref="porcentaje_comision"
                    placeholder="5.40"
                    min="0"
                    step="0.25"
                    max="100"
                    type="number"
                    onkeypress="if(event.keyCode < 46 || event.keyCode > 57 || event.keyCode == 47) event.returnValue = false;"
                    v-model="configuracion.porcentaje_comision"
                  />
                  <span 
                    class="input-group-text" 
                    :class="$store.state.layout.layoutMode == 'dark' ? '' : 'bg-white'"
                  >%</span>
                </div>
              </div>
              <div class="col-md-6 mb-2">
                <label class="fw-semibold font-size-13 mb-1">Adicional a la comisión</label>
                <div class="input-group">
                  <span class="input-group-text" :class="$store.state.layout.layoutMode == 'dark' ? '' : 'bg-white'">
                    {{moneda_seleccionada ? moneda_seleccionada.simbolo : ''}}
                  </span>
                  <input
                    class="form-control"
                    ref="adicional_comision"
                    placeholder="0.30"
                    min="0"
                    max="100"
                    type="number"
                    onkeypress="if(event.keyCode < 46 || event.keyCode > 57 || event.keyCode == 47) event.returnValue = false;"
                    v-model="configuracion.adicional_comision"
                  />
                  <span class="input-group-text" :class="$store.state.layout.layoutMode == 'dark' ? '' : 'bg-white'">
                    {{moneda_seleccionada ? moneda_seleccionada.codigo : ''}}
                  </span>
                </div>
              </div>
              <div class="col-12 mt-2 pt-2 border-top">
                <small class="text-muted font-size-12">
                  <i class="mdi mdi-calculator text-primary me-1"></i>
                  Ejemplo (Monto: 100 {{ moneda_seleccionada ? moneda_seleccionada.codigo : 'USD' }}):
                  Cobro total = <strong>{{ calcularEjemploComision() }} {{ moneda_seleccionada ? moneda_seleccionada.codigo : '' }}</strong>
                </small>
              </div>
            </div>

            <hr style="margin-top: 1.25rem; margin-bottom: 1.25rem;" v-if="false">

            <div class="p-3 bg-light rounded border">
              <h6 class="mb-2 fw-bold font-size-14">
                Pasarela de pagos
                (<a href="https://miserviciodeinternet.com" target="_blank" rel="noopener noreferrer">
                  https://miserviciodeinternet.com
                </a>)
              </h6>
              <p class="font-size-13 text-muted mb-3">
                Para la integración de la pasarela de pago <strong>{{ pasarela.id != null ? '('+pasarela.nombre+')': '' }}</strong>, la comunicación se realiza mediante <strong>API v1</strong> de forma completamente automatizada.
              </p>
              <div class="pt-2 border-top">
                <h6 class="font-size-13 fw-bold mb-2 text-dark">
                  <i class="mdi mdi-information-outline text-primary me-1"></i>
                  ¿Cómo funciona la integración con FlowPay?
                </h6>
                <ul class="font-size-12 text-muted ps-3 mb-0">
                  <li class="mb-1">
                    <strong>Registro Automatizado:</strong> Al activar la pasarela, el sistema registra automáticamente una aplicación API con el nombre de la pasarela y genera su Access Token de autenticación.
                  </li>
                  <li class="mb-1">
                    <strong>Comunicación vía API v1:</strong> La integración de pagos se procesa de forma directa mediante la API v1 sin requerir configuraciones manuales de IPN.
                  </li>
                  <li class="mb-1">
                    <strong>Sincronización de Clientes y CLABE:</strong> Al dar de alta un cliente en ArgusBlack, se crea automáticamente su cuenta en FlowPay y se adjunta su CLABE interbancaria en las notas del cliente para realizar depósitos directos.
                  </li>
                  <li class="mb-1">
                    <strong>Aplicación de Saldo a Favor:</strong> Al activar la pasarela, se activa automáticamente la opción "Usar saldo a favor para el pago de nuevas facturas" en los ajustes de facturación (y se desactiva al desactivar la pasarela).
                  </li>
                  <li>
                    <strong>Desactivación Segura:</strong> Al desactivar la pasarela, la aplicación vinculada y sus credenciales son eliminadas automáticamente para resguardar la seguridad del sistema.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right pb-4">
          <div class="btn-group">
            <button class="btn btn-secondary"
              @click="$router.go(-1)">
              <i class="mdi mdi-chevron-left"></i>
              Atras
            </button>
            <button class="btn btn-success" @click="guardar()" :disabled="bandera_spinner">
              <i
                class="mdi"
                :class="!bandera_spinner ? 'mdi-content-save' : 'mdi-concourse-ci mdi-spin'"
              ></i>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main'
import PasarelaPagoSrv from '@/services/PasarelaPagoSrv'
import MonedaSoportadaPasarelaPagoSrv from '@/services/MonedaSoportadaPasarelaPagoSrv.js'
import AplicacionSrv from '@/services/AplicacionSrv.js'
import SistemaSrv from '@/services/SistemaSrv.js'

export default {
  name: 'EdicionPasarela',
  components: { Layout },
  data: function() {
    return {
      idPasarela: null,
      pasarela: {
        id: null,
        nombre: '',
        default_id_moneda: 4,
        default_porcentaje_comision: 5,
        default_adicional_comision: 5,
        nombre_ruta_ipn: null,
      },
      configuracion: {
        id_pasarela: null,
        activa: 0,
        id_moneda: null,
        comision: 0,
        porcentaje_comision: 0,
        adicional_comision: 0,
      },
      aplicacion: {
        id: null,
        id_foto: null,
        nombre: '',
        activo: 1,
        roles: [{ id:1, nombre:'administrador' }],
        foto: null,
        access_token: ''
      },
      monedas_soportadas: [],
      mostrar_access_token: false,
      copiado_token: false,
      copiado_api_url: false,
      bandera_spinner: false
    }
  },
  computed: {
    moneda_seleccionada() {
      let moneda = this.monedas_soportadas.find(mnd => {
        return mnd.id == this.configuracion.id_moneda
      })

      return moneda
    }
  },
  created: function() {
    var self = this 

    self.idPasarela = this.$route.params.id

    self.cargarPasarela()
  },
  methods: {
    calcularEjemploComision() {
      let base = 100
      let porc = parseFloat(this.configuracion.porcentaje_comision) || 0
      let adic = parseFloat(this.configuracion.adicional_comision) || 0
      let total = base + (base * (porc / 100)) + adic
      return total.toFixed(2)
    },
    cargarPasarela: function() {
      var self = this

      PasarelaPagoSrv.pasarelaJSON(self.idPasarela).then(response => {
        self.pasarela = response.data
        self.cargarMonedasSoportadas(function() {
          self.cargarConfiguracionPasarela()
        })
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo cargar la pasarela'
        iu.msg.error(mensaje)
        console.log(error)
      })
    },
    cargarConfiguracionDefault:function() {
      var self = this

      self.configuracion.id_moneda = self.pasarela.default_id_moneda
      self.configuracion.porcentaje_comision = self.pasarela.default_porcentaje_comision
      self.configuracion.adicional_comision = self.pasarela.default_adicional_comision
    },
    cargarConfiguracionPasarela: function() {
      var self = this

      PasarelaPagoSrv.configuracionJSON(this.idPasarela).then(response => {
        self.configuracion = response.data

        let index = this.monedas_soportadas.findIndex(m => {
          return m.id == self.configuracion.id_moneda
        })

        if(index == -1 && self.configuracion.id_moneda != null) self.cargarMonedaFaltante(self.configuracion.id_moneda)
        
        self.buscarAplicacionPorNombre()
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo cargar la confirguracion de la pasarela de pagos'
        let code = error?.response?.data?.codigo || null

        if(code == 404) {
          self.cargarConfiguracionDefault()
        } else {
          iu.msg.error(mensaje)
          console.log(error)
        }
      })
    },
    cargarMonedaFaltante:function(idMoneda) {
      var self = this

      MonedaSoportadaPasarelaPagoSrv.monedaJSON(idMoneda).then(response => {
        let moneda = response.data
        moneda.soportada = false

        self.monedas_soportadas.push(moneda)
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo cargar las moneda faltante'
        iu.msg.error(mensaje)
        console.log(error)
      })
    },
    cargarMonedasSoportadas: function(callback) {
      var self = this,
        params =  {
          id_pasarela: self.idPasarela
        }

      MonedaSoportadaPasarelaPagoSrv.monedasJSON(params).then(response => {
        self.monedas_soportadas = response.data

        self.monedas_soportadas.forEach(m => {
          m.soportada = true
        })
        
        if(callback) callback()
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo cargar las monedas soportadas para la pasarela de pagos'
        iu.msg.error(mensaje)
        console.log(error)
      })
    },
    cargarAplicacion: function(idAplicacion, callback) {
      var self = this

      if (!idAplicacion) return

      AplicacionSrv.aplicacionJSON(idAplicacion).then(response => {
        self.aplicacion = response.data

        if (callback) callback()
      }).catch(error => {
        console.log('No se pudo cargar la aplicación:', error)
        if (callback) callback()
      })
    },
    buscarAplicacionPorNombre: function(callback) {
      var self = this
      let nombrePasarela = self.pasarela.nombre ? self.pasarela.nombre : 'FlowPay'
      let params = { dato: nombrePasarela }

      AplicacionSrv.aplicacionesJSON(params).then(response => {
        let lista = response.data
        if (Array.isArray(lista)) {
          let appEncontrada = lista.find(a => a.nombre && a.nombre.trim().toLowerCase() === nombrePasarela.trim().toLowerCase())
          if (appEncontrada) {
            self.cargarAplicacion(appEncontrada.id, function() {
              if (callback) callback(true, appEncontrada)
            })
            return
          }
        }
        if (callback) callback(false, null)
      }).catch(error => {
        console.log(error)
        if (callback) callback(false, null)
      })
    },
    registrarAplicacion: function() {
      var self = this
      let nombrePasarela = self.pasarela.nombre ? self.pasarela.nombre : 'FlowPay'

      if (self.aplicacion.id && self.aplicacion.access_token) return

      self.bandera_spinner = true

      let app = {
        nombre: nombrePasarela,
        activo: 1,
        roles: [1]
      }

      AplicacionSrv.guardar(app).then(response => {
        let appId = typeof response.data === 'object' ? (response.data.id || response.data) : response.data

        if (appId && typeof appId !== 'object') {
          self.cargarAplicacion(appId, function() {
            iu.msg.success(`Se registró la aplicación ${nombrePasarela} y se generó el Access Token correctamente.`)
          })
        } else if (response.data && response.data.access_token) {
          self.aplicacion = response.data
          iu.msg.success(`Se registró la aplicación ${nombrePasarela} y se generó el Access Token correctamente.`)
        } else {
          self.buscarAplicacionPorNombre(function() {
            iu.msg.success(`Se registró la aplicación ${nombrePasarela} y se generó el Access Token correctamente.`)
          })
        }
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo registrar la aplicación'
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        self.bandera_spinner = false
      })
    },
    eliminarAplicacion: function() {
      var self = this
      let idApp = self.aplicacion.id

      if (idApp) {
        self.ejecutarEliminarAplicacion(idApp)
      } else {
        self.buscarAplicacionPorNombre(function(encontrada, app) {
          if (encontrada && app && app.id) {
            self.ejecutarEliminarAplicacion(app.id)
          }
        })
      }
    },
    ejecutarEliminarAplicacion: function(idApp) {
      var self = this
      let nombrePasarela = self.pasarela.nombre ? self.pasarela.nombre : 'FlowPay'

      self.bandera_spinner = true

      AplicacionSrv.eliminar(idApp).then(() => {
        self.aplicacion = {
          id: null,
          id_foto: null,
          nombre: '',
          activo: 1,
          roles: [{ id: 1, nombre: 'administrador' }],
          foto: null,
          access_token: ''
        }
        iu.msg.warning(`La aplicación ${nombrePasarela} fue eliminada al desactivar la pasarela.`)
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo eliminar la aplicación'
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        self.bandera_spinner = false
      })
    },
    cerrar: function() {
      this.$router.go(-1)
    },
    copiarAccessToken() {
      var self = this
      if (!self.aplicacion.access_token) {
        iu.msg.warning('No hay Access Token disponible para copiar.')
        return
      }

      var aux = document.createElement("input");
      aux.setAttribute("value", self.aplicacion.access_token);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);

      self.copiado_token = true
      setTimeout(() => {
        self.copiado_token = false
      }, 2000)

      iu.msg.success('El Access Token ha sido copiado correctamente al portapapeles.')
    },
    copiarApiUrl() {
      var self = this
      var aux = document.createElement("input");
      aux.setAttribute("value", "https://apiv1.argus.black");
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);

      self.copiado_api_url = true
      setTimeout(() => {
        self.copiado_api_url = false
      }, 2000)

      iu.msg.success('El Endpoint API de comunicación ha sido copiado al portapapeles.')
    },
    guardar: function() {
      var self = this 

      if(self.configuracion.comision == true && (self.configuracion.porcentaje_comision === '' || self.configuracion.porcentaje_comision === null)){
        iu.msg.warning('No puede ir vacío el campo porcentaje de comisión')
        self.$refs.porcentaje_comision.select()
        return
      }

      if(self.configuracion.comision == true && (self.configuracion.adicional_comision === '' || self.configuracion.adicional_comision === null)){
        iu.msg.warning('No puede ir vacío el campo adicional a la comisión')
        self.$refs.adicional_comision.select()
        return
      }

      let config = {
        id_pasarela: self.pasarela.id,
        activa: self.configuracion.activa,
        id_moneda: self.configuracion.id_moneda,
        comision: self.configuracion.comision,
        porcentaje_comision: self.configuracion.porcentaje_comision,
        adicional_comision: self.configuracion.adicional_comision,
      }

      self.bandera_spinner = true

      PasarelaPagoSrv.guardarConfiguracion(self.pasarela.id, config).then(response => {
        self.actualizarAjusteSaldoAFavor(self.configuracion.activa ? 1 : 0)
        iu.msg.success("Se actualizaron correctamente los datos de la pasarela de pagos")
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo guardar la configuración de la pasarela'
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        self.bandera_spinner = false
      })
    },
    mensajePasarelaActiva(){
      var self = this 

      let nombre = self.pasarela.nombre || 'FlowPay'
      let estado = self.configuracion.activa ? 'activo' : 'inactivo'

      iu.msg.info(`La pasarela ${nombre}, se encuentra ${estado} en mi servicio de internet.`, {
        position: `top-right`, duration: 4000,
        dismissible: true, pauseOnHover: true,
        useDefaultCss: true
      })

      if (self.configuracion.activa) {
        self.buscarAplicacionPorNombre(function(encontrada) {
          if (!encontrada) {
            self.registrarAplicacion()
          }
        })
        self.actualizarAjusteSaldoAFavor(1)
      } else {
        self.eliminarAplicacion()
        self.actualizarAjusteSaldoAFavor(0)
      }

      self.guardar()
    },
    actualizarAjusteSaldoAFavor: function(activo) {
      var self = this
      let valor = (activo === 1 || activo === true || (activo === undefined && self.configuracion.activa)) ? 1 : 0

      let ajustes = {
        aplicar_saldo_favor_a_facturas_pendientes_pago: valor
      }

      SistemaSrv.actualizar(ajustes).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo actualizar el ajuste de saldo a favor'
        iu.msg.error(mensaje)
        console.log(error)
      })
    }
  }
}
</script>